import inventoryAPI from '@/services/API/inventory'

//Fetch customer based on a search string
const fetchStockItems = function({ commit, state}, {query, inventoryId, inStock}) {
  if(inStock==null){inStock=true}
  if(state.itemsOudated){
    return inventoryAPI.fetchProducts({paging:'no', active:true, inStock, searchTerms:query, inventoryId})
      .then(products=>{
        commit('SET_IN_STOCK_ITEMS', products);
      })
  }
};

const invalidateStockItems = function({commit}){
  commit('INVALIDATE_STOCK_ITEMS');
}

const fetchAllItems = function({ commit, state}, query) {
  if(state.allItemOutdated){
    return inventoryAPI.fetchProducts({paging:'no', active:true, inStock:false})
      .then(products=>{
        commit('SET_IN_ALL_ITEMS', products);
      })
  }
};

const invalidateAllItems = function({commit}){
  commit('INVALIDATE_ALL_ITEMS');
}


export default {
  fetchStockItems,
  invalidateStockItems,
  fetchAllItems,
  invalidateAllItems
};
